import React from 'react';

import Icon from '../../../assets/images/relogio.svg';

export const IconError = (): JSX.Element => {
  return <img src={Icon} alt="Icone" />;
};
